import Config from 'react-native-config';

export const WEBVIEW_DEV = 'dev';
export const WEBVIEW_STAGE = 'stage';
export const WEBVIEW_PRD = 'prd';
const webviewUrl = {
  CMSWebview: {
    dev: 'https://weixin.zijinshe.com/cms/webapp/classroom-stage/answer/index.html',
    [WEBVIEW_STAGE]:
      'https://weixin.zijinshe.com/cms/webapp/classroom/answer/index.html',
    [WEBVIEW_PRD]:
      'https://weixin.zijinshe.com/cms/webapp/classroom/answer/index.html',
  },
  AI: {
    [WEBVIEW_DEV]: 'http://192.168.1.172:80',
    // [WEBVIEW_DEV]: 'https://dev.classroom.chat.guoqian.cc',
    // [WEBVIEW_DEV]: 'http://192.168.2.3:80',
    [WEBVIEW_STAGE]: 'https://dev.classroom.chat.guoqian.cc',
    [WEBVIEW_PRD]: 'https://onepad.zijinshe.com',
  },
};
export const CMSWebviewURL = webviewUrl.CMSWebview[Config.ENV_NAME];
export const AIWebviewURL = webviewUrl.AI[Config.ENV_NAME];

export default webviewUrl;
